//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import jQuery from 'jquery';
import datepicker from 'jquery-ui/ui/widgets/datepicker.js';
import moment from 'moment-timezone';

export default {
  props: {
    value: Date,
    timezone: {
      type: String,
      default: moment.tz.guess(),
    },
    settings: Object,
  },
  data() {
    let _this = this;
    let datepickerSettings = this.$options.settings || this.settings || {};
    datepickerSettings = jQuery.extend(
      {},
      {
        dateFormat: 'yy-mm-dd',
        // The minDate is the earlier of now / the initial value.
        minDate: new Date(Math.min(this.value.getTime(), new Date().getTime())),
        dayNamesMin: [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ]
      },
      datepickerSettings,
      {
        onSelect : dateText => {
          let dateValue = moment(jQuery.datepicker.parseDate(
            datepickerSettings.dateFormat,
            dateText
          )).format('YYYY-MM-DD');
          this.dateValue = moment.tz(dateValue, this.timezone).toDate();
          this.onInput();
        }
      }
    );

    return {
      dateValue: this.value,
      datepickerSettings,
    };
  },
  methods: {
    onInput() {
      this.$emit('input', this.dateValue);
    }
  },
  computed: {
    dateString() {
      return jQuery.datepicker.formatDate(
        this.datepickerSettings.dateFormat,
        this.value
      );
    }
  },
  mounted() {
    jQuery('.date-input', this.$el).datepicker(this.datepickerSettings);
  },
}



// WEBPACK FOOTER //
// ./app/components/molecules/input-date/input-date.vue